import { machineSchedulingOptionSuffix } from './machineScheduling';

/**
 * Labels for machine dropdowns (hourly + daily + per-load when present).
 * @param {object} m machine row
 * @param {string} [referenceDateYmd] for scheduling block check; defaults to today
 */
export const formatMachineOptionLabel = (m, referenceDateYmd) => {
  const bits = [m.name];
  if (m.hourlyRate != null && m.hourlyRate !== '') {
    bits.push(`$${parseFloat(m.hourlyRate).toFixed(2)}/hr`);
  }
  if (m.dayRate != null && m.dayRate !== '') {
    bits.push(`$${parseFloat(m.dayRate).toFixed(2)}/day`);
  }
  if (m.loadRate != null && m.loadRate !== '') {
    bits.push(`$${parseFloat(m.loadRate).toFixed(2)}/load`);
  }
  return bits.join(' — ') + machineSchedulingOptionSuffix(m, referenceDateYmd);
};

/**
 * Machine dropdown label without rates (e.g. foreman): name, optional model, scheduling suffix.
 */
export const formatMachineOptionLabelNoFinance = (m, referenceDateYmd) => {
  const bits = [m.name];
  if (m.model != null && String(m.model).trim() !== '') {
    bits.push(String(m.model).trim());
  }
  return bits.join(' — ') + machineSchedulingOptionSuffix(m, referenceDateYmd);
};

/**
 * Preview line amount for ticket form (matches server: daily = day rate × 1 day per line).
 */
export const getTicketLineAmount = (item, machines) => {
  const m = machines.find((x) => String(x.id) === String(item.machineId));
  if (!m) return 0;
  if (item.rateType === 'daily') {
    return parseFloat(m.dayRate) || 0;
  }
  if (item.rateType === 'load') {
    return (parseFloat(item.loadsUsed) || 0) * (parseFloat(m.loadRate) || 0);
  }
  // hourly (default)
  return (parseFloat(item.hoursUsed) || 0) * (parseFloat(m.hourlyRate) || 0);
};
